import AccountHub from '../components/Account/AccountHub';
import AccountNotifications from '../components/Account/AccountNotifications';
import AgentSettlements from '../components/AgentSettlements';
import AllPayments from '../components/AllPayments';
import AllVendRequests from '../components/AllVendRequests';
import Approvals from '../components/Approvals';
import ApprovedTransactions from '../components/ApprovedTransactions';
import Businesses from '../components/Businesses';
import Campaigns from '../components/Campaigns';
import Careers from '../components/Careers';
import CheckMeter from '../components/CheckMeter';
// import Unviewed from '../components/Unviewed';
import Config from '../components/Config';
import Dashboard from '../components/Dashboard';
import Domains from '../components/Domains';
import Facilities from '../components/Facilities';
import FacilityVerifications from '../components/FacilityVerification';
// import UntreatedTransactions from '../components/UntreatedTransactions';
import FailedLoginAttempts from '../components/FailedLoginAttempts';
import FraudEvents from '../components/FraudEvents';
import Gateways from '../components/Gateways';
// import GenerateToken from '../components/GenerateToken';
import Merchants from '../components/Merchants';
import MyApprovalRequests from '../components/MyApprovalRequests';
import Orders from '../components/Orders';
import PaymentGateways from '../components/PaymentGateways';
import Payments from '../components/Payments';
import Promotions from '../components/Promotions';
import ProviderEvent from '../components/ProviderEvent';
import Refunds from '../components/Refunds';
import SendPushNotifications from '../components/SendPushNotifications';
import Services from '../components/Services';
import SetSupportSupervisor from '../components/SetSupportSupervisor';
import Settings from '../components/Settings';
// import Reports from '../components/Reports';
// import AdroitCheques from '../components/AdroitCheques';
// import ApiUsersRefund from '../components/ApiUsersRefund';
import Supervisors from '../components/Supervisors';
import Surveys from '../components/Survery';
import UserSessions from '../components/UserSessions';
import Users from '../components/Users';
import VirtualAccounts from '../components/VirtualAccounts';
import Watchlist from '../components/Watchlist';
import ManualTopups from '../components/ManualTopups';
import GmailAccounts from '../components/GmailAccounts';

// Sidebar order comes from `group` + NAV_GROUPS (see ./navGroups.js) — not from
// this array's order, and no longer from an alphabetical sort. Within a group,
// items render in the order they appear below.
const routes = [
  // ── Pinned above the groups ────────────────────────────────────────────────
  // Insights (`/`) is also pinned to the top of the sidebar, but it is declared
  // LAST in this array — see the note beside it.
  {
    path: '/approvals',
    name: 'Approvals',
    icon: 'ui-1_check',
    badge: 'approvals',
    pinned: 'top',
    // Pinned items can't rely on array position (see the `/` note at the end),
    // so they order themselves explicitly.
    navOrder: 1,
    component: Approvals,
  },

  // ── Sales — the commercial record ──────────────────────────────────────────
  {
    path: '/orders',
    name: 'Orders',
    icon: 'shopping_credit-card',
    group: 'sales',
    component: Orders,
  },
  {
    path: '/all-payments',
    name: 'Payments',
    icon: 'shopping_credit-card',
    group: 'sales',
    component: Payments,
  },
  {
    path: '/refunds',
    name: 'Refunds',
    icon: 'ui-2_time-alarm',
    group: 'sales',
    component: Refunds,
  },
  // {
  //   path: '/transactions',
  //   name: 'All Transactions',
  //   icon: 'business_briefcase-24',
  //   component: AllTransactions,
  // },
  // {
  //   path: '/disputes',
  //   name: 'Disputes',
  //   icon: 'ui-2_time-alarm',
  //   component: Disputes,
  // },
  // {
  //   path: '/refundables',
  //   name: 'Refundables',
  //   icon: 'ui-2_time-alarm',
  //   component: Refundables,
  // },
  // {
  //   path: '/untreated',
  //   name: 'Untreated Transactions',
  //   icon: 'ui-2_time-alarm',
  //   component: UntreatedTransactions,
  // },

  // ── Support — grouped by job rather than domain: the screens an agent
  // reaches for when a customer contacts them.
  {
    path: '/approved',
    name: 'Approved Transactions',
    icon: 'ui-2_time-alarm',
    group: 'support',
    component: ApprovedTransactions,
  },
  {
    // Superseded by /orders. Kept reachable, and explicitly labelled, until the
    // team has fully moved over — it reads the older /transactions/payments
    // endpoint, while /all-payments reads /payments.
    path: '/payments',
    name: 'All Payments (Legacy)',
    icon: 'shopping_credit-card',
    group: 'support',
    component: AllPayments,
  },
  {
    path: '/manual-topups',
    name: 'Manual Topups',
    icon: 'business_money-coins',
    group: 'support',
    component: ManualTopups,
  },
  {
    path: '/checkmeter',
    name: 'Check Meter',
    icon: 'location_map-big',
    group: 'support',
    component: CheckMeter,
  },

  // ── Services & Integrations — the third parties we vend through and collect
  // through, plus their request/event logs.
  {
    path: '/requests',
    name: 'Vend Requests',
    icon: 'shopping_credit-card',
    group: 'services',
    component: AllVendRequests,
  },
  {
    path: '/services',
    name: 'Services',
    icon: 'gestures_tap-01',
    group: 'services',
    resource: 'services',
    action: 'get',
    component: Services,
  },
  {
    // Service providers (discos) — distinct from Payment Gateways below.
    path: '/gateways',
    name: 'Gateways',
    icon: 'gestures_tap-01',
    group: 'services',
    resources: 'gateways',
    action: 'get',
    component: Gateways,
  },
  {
    path: '/provider-events',
    name: 'Provider Events',
    icon: 'business_money-coins',
    group: 'services',
    resource: 'provider-events',
    action: 'get',
    component: ProviderEvent,
  },
  {
    path: '/payment-gateways',
    name: 'Payment Gateways',
    icon: 'gestures_tap-01',
    group: 'services',
    resource: 'payment-gateways',
    action: 'get',
    component: PaymentGateways,
  },
  {
    path: '/virtual-accounts',
    name: 'Virtual Accounts',
    icon: 'gestures_tap-01',
    group: 'services',
    component: VirtualAccounts,
  },

  // ── Business — partners and channels. Ordered merchant-side, then
  // agent-side, then facilities.
  {
    path: '/merchants',
    name: 'Merchants',
    icon: 'users_single-02',
    group: 'business',
    resource: 'merchants',
    action: 'get',
    component: Merchants,
  },
  {
    path: '/businesses',
    name: 'Businesses',
    icon: 'users_single-02',
    group: 'business',
    resource: 'businesses',
    action: 'get',
    component: Businesses,
  },
  {
    path: '/settlements',
    name: 'Agent Settlements',
    icon: 'travel_info',
    group: 'business',
    resource: 'agent-settlements',
    action: 'get',
    component: AgentSettlements,
  },
  {
    path: '/facilities',
    name: 'Facilities',
    icon: 'files_box',
    group: 'business',
    component: Facilities,
  },
  {
    path: '/facility-verifications',
    name: 'Facility Verifications',
    icon: 'files_box',
    group: 'business',
    component: FacilityVerifications,
  },

  // ── Users & Access ─────────────────────────────────────────────────────────
  {
    path: '/users',
    name: 'Users',
    icon: 'users_single-02',
    group: 'customers',
    component: Users,
  },
  {
    path: '/supervisors',
    name: 'Supervisors',
    icon: 'users_single-02',
    group: 'customers',
    component: Supervisors,
  },
  {
    path: '/supervisor',
    name: 'Set Supervisor',
    icon: 'travel_info',
    group: 'customers',
    resource: 'support-supervisor',
    action: 'get',
    component: SetSupportSupervisor,
  },
  {
    // Access domains (B2B, B2C, MERCHANT, AGENT…), not partner organisations.
    path: '/domains',
    name: 'Domains',
    icon: 'business_globe',
    group: 'customers',
    component: Domains,
  },
  {
    path: '/sessions',
    name: 'User Sessions',
    icon: 'gestures_tap-01',
    group: 'customers',
    component: UserSessions,
  },
  {
    path: '/watchlists',
    name: 'Watchlists',
    icon: 'gestures_tap-01',
    group: 'customers',
    component: Watchlist,
  },

  // ── Risk & Compliance ──────────────────────────────────────────────────────
  {
    path: '/fraud-events',
    name: 'Fraud Events',
    icon: 'business_money-coins',
    group: 'risk',
    resource: 'fraud-events',
    action: 'get',
    component: FraudEvents,
  },
  {
    path: '/failedlogins',
    name: 'Failed Login Attempts',
    icon: 'users_single-02',
    group: 'risk',
    component: FailedLoginAttempts,
  },

  // ── Growth & Content ───────────────────────────────────────────────────────
  {
    path: '/campaigns',
    name: 'Campaigns',
    icon: 'gestures_tap-01',
    group: 'growth',
    component: Campaigns,
  },
  {
    path: '/promotions',
    name: 'Promotions',
    icon: 'business_money-coins',
    group: 'growth',
    resource: 'promotions',
    action: 'get',
    component: Promotions,
  },
  {
    path: '/send-notification',
    name: 'Send Push Notification',
    icon: 'business_briefcase-24',
    group: 'growth',
    resource: 'push-notifications',
    action: 'get',
    component: SendPushNotifications,
  },
  {
    path: '/surveys',
    name: 'Surveys',
    icon: 'gestures_tap-01',
    group: 'growth',
    component: Surveys,
  },
  {
    path: '/careers',
    name: 'Careers',
    icon: 'gestures_tap-01',
    group: 'growth',
    component: Careers,
  },
  {
    path: '/gmail-accounts',
    name: 'Gmail Accounts',
    icon: 'ui-1_email-85',
    group: 'growth',
    component: GmailAccounts,
  },

  // ── Pinned below the groups ────────────────────────────────────────────────
  {
    path: '/settings',
    name: 'Settings',
    icon: 'ui-2_settings-90',
    pinned: 'bottom',
    resource: 'application-config',
    action: 'get',
    component: Settings,
  },

  // ── Not in the sidebar ─────────────────────────────────────────────────────
  {
    path: '/config',
    name: 'Config',
    icon: 'files_box',
    resource: 'application-config',
    action: 'get',
    component: Config,
    hidden: true,
  },
  {
    // Personal pages — reachable only via the Header dropdown. `hidden` keeps
    // them out of the sidebar (see getRoutes in utils.js) while still rendering
    // as routes in Main.js.
    path: '/account',
    name: 'My Account',
    icon: 'users_single-02',
    hidden: true,
    component: AccountHub,
  },
  {
    path: '/my-requests',
    name: 'My Approval Requests',
    icon: 'ui-1_send',
    hidden: true,
    component: MyApprovalRequests,
  },
  {
    path: '/notifications',
    name: 'Notifications',
    icon: 'ui-1_bell-53',
    hidden: true,
    component: AccountNotifications,
  },
  // {
  //   path: '/adroitcheque',
  //   name: 'Adroit Cheques',
  //   roles: [role.FINANCE],
  //   icon: 'ui-2_time-alarm',
  //   component: AdroitCheques,
  // },
  // {
  //   path: '/creditapiuser',
  //   name: 'Credit API User',
  //   roles: [role.SUPER_ADMIN],
  //   icon: 'travel_info',
  //   component: ApiUsersRefund,
  // },
  // {
  //   path: '/reports',
  //   name: 'Generate Reports',
  //   icon: 'travel_info',
  //   component: Reports,
  // },
  // {
  //   path: '/generate',
  //   name: 'Generate Token',
  //   icon: 'business_briefcase-24',
  //   component: GenerateToken,
  // },
  // {
  //   path: '/unviewed',
  //   name: 'Unviewed Tokens',
  //   icon: 'business_bulb-63',
  //   component: Unviewed,
  // },

  // ⚠ Keep this entry LAST. Main.js renders every route as a non-exact <Route>
  // inside a <Switch>, so `path: '/'` matches *every* URL — its position here is
  // the only thing making it the fallback rather than swallowing /orders and the
  // rest. Its position in the sidebar comes from `pinned`, not from this array,
  // so it renders at the top of the nav regardless.
  {
    path: '/',
    name: 'Insights',
    icon: 'business_chart-bar-32',
    pinned: 'top',
    navOrder: 0,
    component: Dashboard,
  },
];

export default routes;
